import {setDefaultEvent} from './mprExecutiveSummary';

const phaseIds = [1, 2, 3, 4, 5, 6, 7, 8, '8a', 9];

export default function () {
    //Attach blur events
    attachBlurEvents();
    setDefaultEvent();
    preventEnterRefresh();

    //Calculate Variances and Totals
    updatePageNumbers();

    //Attach EventId Events
    attachWorkflowEventId();
}

const calculateVariances = () => {
    let $estimateRows = $('.js-estimate-row');

    $.each($estimateRows, function (index, ele) {
        let $originalEstimate = $(ele).find('[id*="__OriginalEstimate"]'),
            $revisedEstimate  = $(ele).find('[id*="__RevisedEstimate"]'),
            $variance         = $(ele).find('.js-variance'),
            $varianceRaw      = $(ele).find('.js-variance-raw'),
            variance          = Number($originalEstimate.val()) - Number($revisedEstimate.val());
        $variance.text(kendo.toString(variance, '##,#.00'));
        $varianceRaw.val(variance);
    });
};

const calculateTotals = () => {
    let revisedTotals = 0,
        originalTotals = 0;
    for (let i = phaseIds.length - 1; i >= 0; i--) {
        let phaseId = phaseIds[i];
        let $section = $(`[data-phase="${phaseId}"]`);
        if ($section.length) {
            let originalTotal = 0;
            let $originalEstimates = $section.find('[id*="__OriginalEstimate"]');
            $.each($originalEstimates, function (index, ele) {
                originalTotal += Number(ele.value);
            });

            $(`.js-phase${phaseId}-orig-estimate-total-raw`).val(originalTotal);
            $(`.js-phase${phaseId}-orig-estimate-total`).text(kendo.toString(originalTotal, '##,#.00'));
            
            originalTotals += originalTotal;
            
            let revisedTotal = 0;
            let $revisedEstimates = $section.find('[id*="__RevisedEstimate"]');
            $.each($revisedEstimates, function (index, ele) {
                revisedTotal += Number(ele.value);
            });

            $(`.js-phase${phaseId}-revised-estimate-total-raw`).val(revisedTotal);
            $(`.js-phase${phaseId}-revised-estimate-total`).text(kendo.toString(revisedTotal, '##,#.00'));
            
            revisedTotals += revisedTotal;

            $(`.js-phase${phaseId}-total-variance`).text(kendo.toString(originalTotal - revisedTotal, '##,#.00'));
        }
    }
    $('.js-total-orig-estimate-total-raw').val(originalTotals);
    $('.js-total-orig-estimate-total').text(kendo.toString(originalTotals, '##,#.00'));
    $('.js-total-revised-estimate-total-raw').val(revisedTotals);
    $('.js-total-revised-estimate-total').text(kendo.toString(revisedTotals, '##,#.00'));
    $('.js-total-total-variance').text(kendo.toString(originalTotals - revisedTotals, '##,#.00'));
};

const attachBlurEvents = () => {
    let $revisedEstimates = $('[id*="__RevisedEstimate"]');
    if ($revisedEstimates.length) {
        $revisedEstimates.blur(function () {
            updatePageNumbers();
        });
    }
};

const preventEnterRefresh = () => {
    let $revisedEstimates = $('[id*="__RevisedEstimate"]');
    if ($revisedEstimates.length) {
        $revisedEstimates.on('keydown', function(e){
            if ( e.which === 13 || e.keyCode === 'Enter' )
            {
                $(this).next().focus();
                return false;
            }
        });
    }
};

const updatePageNumbers = () => {
    calculateVariances();
    calculateTotals();
};

const attachWorkflowEventId = () => {
    let $approvalBtn = $('[id*=approvalBtn]');

    if ($approvalBtn.length) {
        $approvalBtn.click(function () {
            $('#BaselineEstimateRevisions_EventTriggerId').val(1);
            let role = this.id.split('_')[1];
            $('#Pin').val($(`#Pin_${role}`).val());
        });
    }
    let $rejectBtn = $('#resetApprovalBtn');
    if ($rejectBtn.length) {
        $rejectBtn.click(function () {
            $('#BaselineEstimateRevisions_EventTriggerId').val(2);
        });
    }
};